/* Movatic WMS — Frontend | CesarFilho 932048016
   Arquivo: src/pages/catalog/UOMs.tsx

   O que faz:
   - Tenta descobrir automaticamente o endpoint correto das UOMs (candidatos mais comuns).
   - Quando encontra, delega a listagem para o nosso <CrudList />.
   - Mostra um aviso amigável se nenhuma rota responder (404).
*/

import { useEffect, useState } from 'react'
import CrudList from '@/components/CrudList'
import { api } from '@/lib/api'

/** Candidatos usuais para UOMs no DRF */
const CANDIDATES = [
    '/api/product/uoms/',
    '/api/product/uom/',
    '/api/product/uoms-list/',
    '/api/uoms/',
]

export default function UOMs() {
    const [endpoint, setEndpoint] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)

    // Descobre a primeira rota que responder 200/204
    useEffect(() => {
        let cancelled = false
            ; (async () => {
                for (const path of CANDIDATES) {
                    try {
                        // Basta uma chamada leve (página 1) para testar
                        await api.get(path, { params: { page: 1, page_size: 1 } })
                        if (!cancelled) {
                            setEndpoint(path)
                            setError(null)
                        }
                        return
                    } catch (e: any) {
                        // segue tentando os demais
                    }
                }
                if (!cancelled) {
                    setEndpoint(null)
                    setError(
                        `Nenhum endpoint de UOM encontrado (testados: ${CANDIDATES.join(', ')})`
                    )
                }
            })()
        return () => {
            cancelled = true
        }
    }, [])

    // Colunas padrão (mapeiam direto o serializer comum)
    const columns = [
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Descrição' },
    ] as const

    return (
        <div className="grid gap-4">
            <div className="card p-4">
                <h2 className="text-lg font-semibold">Unidades de Medida (UOM)</h2>
                {error && (
                    <div className="mt-2 text-sm text-red-500">
                        Aviso: {error}. Confira as rotas do backend.
                    </div>
                )}
            </div>

            <div className="card p-4">
                {endpoint ? (
                    <CrudList title="UOMs" endpoint={endpoint} columns={columns as any} />
                ) : (
                    <div className="text-sm text-neutral-500">Sem dados</div>
                )}
            </div>
        </div>
    )
}
